import React, { useState, useEffect } from 'react';
import { Accordion, Card, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { cloneDeep, isEmpty } from 'lodash';
import Select from 'react-select';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as action from '../Store/SystemMasters.action';
import TextCard from './TextCard';
import DropdownCard from './Dropdown';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function CustomAttrSave(isCustomAttr, t) {
  return isCustomAttr ? (
    <Spinner animation="border" />
  ) : (
    <>
      <span className="icon-Save c-button-align f-20 mr-2" /> {t('PRODUCT_IDENTIFIER.SAVE')}
    </>
  );
}

function CustomAttributeBomMaster({ parentState, parentSetState }) {
  const { t } = useTranslation('common');
  const { CheckActionPermission } = useComponent();
  const dispatch = useDispatch();
  const [CustomAttrBtnDisable, setCustomAttrBtnDisable] = useState(false);
  const [isCustomAttrUnique, setIsCustomAttrUnique] = useState(true);
  const [buttonDownCustomAttr, setButtonDownCustomAttr] = useState(true);
  const [isLoadingCustomAttr, setIsLoadingCustomAttr] = useState(false);
  const [showCustomAttr, setShowCustomAttr] = useState(false);
  const [bomSubTypeSelectData, setbomSubTypeSelectData] = useState(null);
  const [scrollEl, setScrollEl] = useState(null);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [openList, setOpenList] = useState([]);
  const [isCustomAttr, setIsCustomAttr] = useState(false);
  const [optionIds, setOptionDeleteId] = useState('');

  const [state, setState] = useState({
    dropDownTextList: [],
    modifiedList: [],
    activeType: {},
    dropdownOptionList: [],
  });
  const typeList = [
    { name: 'Dropdown', value: 'dropdown' },
    { name: 'Text', value: 'text' },
    { name: 'Multi Dropdown', value: 'Multi Dropdown' },
  ];
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const customBomAttributeMaster = 'custom-bom-attribute-master';
  const { userInfo } = UserDetails;
  const loggedInUserId = userInfo.userId;
  const { BOMTypeList, customAttributeBomList } = SystemMastersDetails;
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'delete');
  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  const labelTmpObj = {
    keyName: '',
    isLable: true,
    type: null,
    isActive: true,
    isChecked: true,
    _id: '',
    isEmpty: false,
    isNew: true,
    productType: [],
  };
  const valueTmpObj = {
    keyName: '',
    isLable: false,
    type: null,
    lableId: null,
    isActive: true,
    isChecked: true,
    _id: '',
    isEmpty: false,
    isNew: true,
    productType: [],
  };

  const getCustomBomAttributeList = async () => {
    if (!bomSubTypeSelectData) return;
    await dispatch(action.getBomCustomAttribute({ bomTypeID: bomSubTypeSelectData._id }));
  };

  useEffect(() => {
    if (!bomSubTypeSelectData) return;
    const fetchBOMAttributes = async () => {
      try {
        await dispatch(action.getBomCustomAttribute({ bomTypeID: bomSubTypeSelectData._id }));
      } catch (error) {
        console.error('Error fetching BOM attributes:', error);
      }
    };

    fetchBOMAttributes();
  }, [bomSubTypeSelectData, dispatch]);

  const callApi = async () => {
    setButtonDownCustomAttr(!buttonDownCustomAttr);
    setIsLoadingCustomAttr(true);
    setShowCustomAttr(buttonDownCustomAttr);
    if (buttonDownCustomAttr) {
      getCustomBomAttributeList();
      const bomTypeparams = {
        isAllRecord: true,
      };
      await dispatch(action.getBOMTypeDetails(bomTypeparams));
    }
    setIsLoadingCustomAttr(false);
  };

  const handleValueChanged = (event, i, parentIndex) => {
    const valueText = [...state.modifiedList];
    valueText[parentIndex].options[i].keyName = event.target.value;
    setState((prevState) => ({
      ...prevState,
      modifiedList: valueText,
    }));
  };

  const btnCall = () => {
    if (buttonDownCustomAttr === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };

  const addCustomAttr = async () => {
    const totalCards = [
      ...customAttributeBomList.filter((element) => element.isLable === true && element.type !== state.activeType.value),
      ...(state?.modifiedList || []),
    ].length;

    if (totalCards >= 15) {
      toasterMsg(t('Maximum limit has been reached'), 'danger');
      return;
    }
    if (state.activeType !== null) {
      const tempObj = cloneDeep(labelTmpObj);
      tempObj.bomTypeID = bomSubTypeSelectData?._id;
      tempObj.type = state.activeType.value;

      setState((prevState) => {
        const updatedList = [...prevState.modifiedList, tempObj];
        if (state.activeType === 'Multi Dropdown') {
          setOpenList((prevOpenList) => [...prevOpenList, updatedList.length - 1]);
        }

        return {
          ...prevState,
          modifiedList: updatedList,
        };
      });
    }
  };

  const setModifiedData = (dropdownType, allTypeData) => {
    let filteredData = [];

    if (dropdownType.value === 'dropdown' || dropdownType.value === 'Multi Dropdown') {
      filteredData = allTypeData?.filter((element) => element.isLable === true && element.type === dropdownType.value);
    } else if (dropdownType.value === 'text') {
      filteredData = allTypeData
        .filter((element) => element.type === 'text')
        .map((data) => {
          if (data?.textFieldConfig?.charLimit <= 0) {
            data.textFieldConfig.charLimit = 50;
          }
          return data;
        });
    }

    if (!isEmpty(filteredData)) {
      filteredData.forEach((item) => {
        const children = allTypeData.filter((ele) => ele.lableId === item._id);
        item.values = children;
      });
    }

    setState((prevState) => ({
      ...prevState,
      modifiedList: filteredData,
      activeType: dropdownType,
    }));
  };
  const handleTypeChange = (dropdownType) => {
    const allTypeData = cloneDeep(state.dropDownTextList);
    CustomAttrBtnDisable && setCustomAttrBtnDisable(false);
    setState((prevState) => ({
      ...prevState,
      activeType: dropdownType,
      modifiedList: [],
      isUniqCustomAttrId: [],
    }));

    setModifiedData(dropdownType, allTypeData);
  };

  const handleDropdownChangeBomType = (value) => {
    setbomSubTypeSelectData(value);
    // Only clear lists if the BOM type is different
    if (value?._id !== bomSubTypeSelectData?._id) {
      setState((oldState) => ({
        ...oldState,
        modifiedList: [],
      }));
    }
  };

  const handleCheckboxCA = (e) => {
    const id = e?.target?.id.split('_')[2];
    const list = state.modifiedList?.map((element) => {
      if (element?._id === id) {
        element.isChecked = e?.target?.checked;
      }
      return element;
    });
    setState((oldData) => ({ ...oldData, modifiedList: [...list] }));
  };

  const handleChanged = (event, i) => {
    const freeTextDropdownData = [...state.modifiedList];
    freeTextDropdownData[i] = {
      ...freeTextDropdownData[i],
      keyName: event.target.value?.trimStart(),
      isEmpty: event.target.value === '',
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
    setIsCustomAttrUnique(true);
    const arr = [];
    freeTextDropdownData.forEach((ele, ind) => {
      freeTextDropdownData.forEach((objs, index) => {
        if (ele.keyName === objs.keyName && ind !== index) {
          arr.push(ele);
        }
      });
    });

    setIsCustomAttrUnique(isEmpty(arr));
    let disableCustomAttr = false;
    freeTextDropdownData.forEach((CustomAttrElement) => {
      if (isEmpty(CustomAttrElement?.keyName?.trim())) {
        disableCustomAttr = true;
      }
    });
    setCustomAttrBtnDisable(disableCustomAttr);
  };
  const activeInactiveClicked = (id, valueId) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
    setOptionDeleteId(valueId || null);
  };
  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let c3 = {};
    state.modifiedList.forEach((ele) => {
      if (ele._id === activeInactiveID && !optionIds) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          _id: activeInactiveID,
        };
        c3 = data;
      } else if (ele?.options?.length > 0 && optionIds) {
        const valueEle = ele.options.find((eleValue) => eleValue._id === optionIds);
        if (valueEle) {
          valueEle.isActive = !valueEle.isActive;
          const dataValue = {
            ...valueEle,
            optionIds,
            _id: activeInactiveID,
            loggedInUserId,
          };
          c3 = dataValue;
        }
      }
    });
    await dispatch(action.setBomActiveInactive(c3, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);

    setState((prevState) => ({
      ...prevState,
      modifiedList: [...state.modifiedList],
    }));
  };

  const addValueForLabel = (id, index) => {
    const tempObj = cloneDeep(valueTmpObj);
    tempObj.lableId = id;
    tempObj.type = state.modifiedList[index].type;

    const updatedList = [...state.modifiedList];

    if (!Array.isArray(updatedList[index].options)) {
      updatedList[index].options = [];
    }

    updatedList[index].options.push(tempObj);

    setState((prevState) => ({
      ...prevState,
      modifiedList: updatedList,
    }));
    setOpenList((prev) => (prev.includes(index) ? prev : [...prev, index]));
  };

  const handleDelete = (id, parentI) => {
    if (typeof id === 'number' || id === '') {
      if (typeof parentI === 'number') {
        state.modifiedList[parentI].options = state.modifiedList[parentI].options.filter((_, index) => index !== id);
      } else {
        // Remove only the selected parent ID from modifiedList
        state.modifiedList = state.modifiedList.filter((_, index) => index !== id);
      }

      state.modifiedList.forEach((CustomAttrElement) => {
        if (isEmpty(CustomAttrElement?.keyName?.trim()) && CustomAttrElement.isNew) {
          setCustomAttrBtnDisable(true);
        } else {
          setCustomAttrBtnDisable(false);
        }
      });

      setIsCustomAttrUnique(true);
      setState((prevState) => ({
        ...prevState,
        modifiedList: [...state.modifiedList],
      }));
    } else {
      // Find the selected parent ID as a string
      const selectedParent = parentI !== undefined ? state.modifiedList[parentI]?._id || '' : '';
      // Find the selected option ID as a string
      const selectedOptionId = parentI !== undefined ? state.modifiedList[parentI]?.options?.find((ele) => ele._id === id)?._id || '' : '';

      setDeleteId(selectedParent || id); // Set as a string
      setOptionDeleteId(selectedOptionId); // Set as a string

      setShowConfirmation(true);
    }
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);

    const customAttributePara = {
      loggedInUserId,
      customBomAttributeId: deleteId,
      optionIds: optionIds || null,
      title: customBomAttributeMaster,
    };
    await dispatch(action.deleteBomCustomAttribute(customAttributePara, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setOptionDeleteId(null);
    setState((prev) => ({
      ...prev,
      dropDownTextList: [],
      modifiedList: [],
    }));
    getCustomBomAttributeList();
  };

  const renderDropdownCard = (card, index) => {
    return (
      <DropdownCard
        key={card?.id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        addValueForLabel={addValueForLabel}
        handleValueChanged={handleValueChanged}
        activeInactiveClicked={activeInactiveClicked}
        handleDelete={handleDelete}
        openList={openList}
        setOpenList={setOpenList}
        handleCheckboxCA={handleCheckboxCA}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
      />
    );
  };

  const renderTextCard = (card, index) => {
    return (
      <TextCard
        key={card?.id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        activeInactiveClicked={activeInactiveClicked}
        handleDelete={handleDelete}
        handleCheckboxCA={handleCheckboxCA}
      />
    );
  };
  useEffect(() => {
    if (!isEmpty(customAttributeBomList)) {
      setState((prevState) => ({
        ...prevState,
        dropDownTextList: customAttributeBomList,
      }));
    }
  }, [customAttributeBomList]);

  useEffect(() => {
    if (parentState?.rearrangeModal === 'customBomAttribute') {
      if (state?.activeType?.value === 'dropdown' || isEmpty(state?.activeType)) {
        const filteredData = customAttributeBomList
          .filter((element) => element?.isLable === true && element?.type === 'dropdown')
          .map((data) => ({ name: data?.keyName, _id: data?._id }));
        parentSetState((prevState) => ({
          ...prevState,
          rearrangeData: filteredData,
        }));
      } else {
        const textFilteredData = customAttributeBomList
          .filter((element) => element?.isLable === false && element?.type === 'text')
          .map((data) => ({ name: data?.keyName, _id: data?._id }));
        parentSetState((prevState) => ({
          ...prevState,
          rearrangeData: textFilteredData,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customAttributeBomList, parentState?.rearrangeModal, state?.activeType]);

  useEffect(() => {
    if (isEmpty(state.activeType)) {
      handleTypeChange({ name: 'Dropdown', value: 'dropdown' });
    } else {
      handleTypeChange(state.activeType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.dropDownTextList]);
  const handleSaveCustomAttr = async () => {
    if (!bomSubTypeSelectData || isEmpty(state?.modifiedList)) {
      toasterMsg(t('CUSTOM_BOM_ATTRIBUTE.BOM_CUSTOM_BEFORE_SAVING_MESSAGE'), t('MASTERS.DANGER'));
      return;
    }

    const isAddingNewCard = state?.modifiedList.some((item) => !item._id);

    if (isAddingNewCard && state?.modifiedList.length > 15) {
      toasterMsg(t('CUSTOM_BOM_ATTRIBUTE.MORE_THEN_FIVE_CARDS'), t('MASTERS.DANGER'));
      return;
    }

    const allData = [];

    state?.modifiedList?.forEach((ele) => {
      allData.push(ele);
      ele?.values?.forEach((eleChild) => {
        allData.push(eleChild);
      });
    });

    setIsCustomAttr(true);

    if (!isEmpty(allData)) {
      // Check for empty fields
      const emptyField = allData.filter((custAttrItem) => custAttrItem.keyName === null || custAttrItem.keyName.trim() === '');

      if (!isEmpty(emptyField)) {
        toasterMsg(t('MASTERS.ALL_FIELDS_REQUIRED'), t('MASTERS.DANGER'));
        setState((prevState) => ({
          ...prevState,
          modifiedList: prevState.modifiedList.map((item) => ({
            ...item,
            keyName: item.keyName === null ? '' : item.keyName,
          })),
        }));
        setIsCustomAttr(false);
        return;
      }

      // Check for duplicate keyName values across the modified list
      const seenKeyNames = new Set();
      let duplicateFound = false;
      const updatedModifiedList = state?.modifiedList?.map((modifiedItem) => {
        const trimmedKeyName = modifiedItem?.keyName.trim().toLowerCase();
        if (seenKeyNames.has(trimmedKeyName)) {
          duplicateFound = true;
        } else {
          seenKeyNames.add(trimmedKeyName);
        }

        if (modifiedItem?.type === 'dropdown' && Array.isArray(modifiedItem?.options)) {
          const seenOptions = new Set();
          const filteredOptions = [];

          modifiedItem?.options?.forEach((opt) => {
            const trimmedOptName = opt?.keyName?.trim()?.toLowerCase();
            if (!seenOptions.has(trimmedOptName)) {
              seenOptions.add(trimmedOptName);
              filteredOptions.push(opt);
            } else {
              duplicateFound = true;
            }
          });

          return { ...modifiedItem, options: filteredOptions };
        }
        return modifiedItem;
      });

      if (duplicateFound) {
        toasterMsg(t('CUSTOM_BOM_ATTRIBUTE.DUPLICATE_CARD_ISSUES'), t('MASTERS.DANGER'));
        setIsCustomAttr(false);
        return;
      }

      // Format data before sending
      const formattedData = updatedModifiedList.map((modifiedItem, index) => ({
        _id: modifiedItem?._id || null,
        bomTypeID: modifiedItem.bomTypeID || bomSubTypeSelectData?._id,
        keyName: modifiedItem?.keyName,
        type: modifiedItem?.type,
        isActive: modifiedItem?.isActive,
        seqNumber: index + 1,
        isLable: modifiedItem?.isLable,
        isDeleted: modifiedItem?.isDeleted || false,
        textFieldConfig: modifiedItem?.textFieldConfig || {},
        options:
          (modifiedItem?.type === 'dropdown' || modifiedItem?.type === 'Multi Dropdown') && Array.isArray(modifiedItem?.options)
            ? modifiedItem.options.map((opt, optIndex) => ({
                _id: opt?._id || null,
                keyName: opt.keyName || '',
                isActive: opt.isActive,
                seqNumber: optIndex + 1,
                lableId: opt.lableId,
              }))
            : [],
      }));

      const custAttrParams = {
        keyNames: JSON.stringify(formattedData),
        title: customBomAttributeMaster,
      };

      // Dispatch API call
      await dispatch(action.saveToBomSystemMaster(custAttrParams, t));
      setState((prevState) => ({
        ...prevState,
        dropDownTextList: [],
        modifiedList: [],
        dropdownOptionList: [],
      }));
      getCustomBomAttributeList();
    }

    setIsCustomAttr(false);
  };

  return (
    <>
      <Accordion className="mb-4 master-accordian custom-attribute-master">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('CUSTOM_BOM_ATTRIBUTE.TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              {MasterAddEditAccess && (
                <CustomTooltip tooltipText={t('CUSTOM_BOM_ATTRIBUTE.ADD')} placement="left">
                  <button type="button" onClick={addCustomAttr} className="filter-btn filter-button_add" disabled={CustomAttrBtnDisable || !isCustomAttrUnique}>
                    <span className="text-icon">{t('APPROVE_REJECTS.ADD')}</span>
                    <i className="icon-add" />
                  </button>
                </CustomTooltip>
              )}
              <CustomTooltip placement="left" tooltipText={!buttonDownCustomAttr ? t('CUSTOM_ATTRIBUTES.CLOSE') : t('CUSTOM_ATTRIBUTES.OPEN')}>
                <button onClick={() => callApi()} type="button">
                  {btnCall()}
                </button>
              </CustomTooltip>
            </div>
          </Card.Header>
          {showCustomAttr &&
            (isLoadingCustomAttr ? (
              <Loader />
            ) : (
              <Card.Body>
                {MasterAddEditAccess && (
                  <div className="common-react-select select-container mt-3">
                    <Select
                      options={[...BOMTypeList]}
                      placeholder={t('BOM_TYPE_MASTER.SELECT_BOM_TYPE')}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      name="bomsubtype"
                      value={bomSubTypeSelectData}
                      className="common-select"
                      classNamePrefix="common-select"
                      onChange={handleDropdownChangeBomType}
                      styles={{
                        menuList: (base) => ({ ...base, maxHeight: 175, overflowY: 'scroll' })
                      }}
                    />
                  </div>
                )}
                {bomSubTypeSelectData && (
                  <div className="common-react-select select-container">
                    <Select
                      options={typeList}
                      placeholder={t('CUSTOM_ATTRIBUTES.TYPE_SELECT_PLACEHOLDER')}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option.value}`}
                      name="type"
                      value={state.activeType}
                      className="common-select"
                      classNamePrefix="common-select"
                      onChange={handleTypeChange}
                      disabled={MasterAddEditAccess}
                    />
                  </div>
                )}
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setScrollEl(ref);
                  }}
                >
                  {Array.isArray(state?.modifiedList) &&
                    !isEmpty(state?.modifiedList) &&
                    state?.modifiedList.map((ele, index) => {
                      if (ele?.bomTypeID === bomSubTypeSelectData?._id) {
                        if (ele?.type === 'dropdown' || ele?.type === 'Multi Dropdown') {
                          return renderDropdownCard(ele, index);
                        }
                        return renderTextCard(ele, index);
                      }
                      return null;
                    })}
                </PerfectScrollbar>

                {MasterAddEditAccess && (
                  <div className="section-save">
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button
                        aria-label="Save"
                        type="button"
                        className="btn btn-page-filter btn-white ml-0"
                        onClick={handleSaveCustomAttr}
                        disabled={CustomAttrBtnDisable}
                      >
                        {CustomAttrSave(isCustomAttr, t)}
                      </button>
                    </CustomTooltip>
                  </div>
                )}
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('CUSTOM_ATTRIBUTES.DELETE_CONFIRM_TITLE')}
          message={t('CUSTOM_ATTRIBUTES.DELETE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('CUSTOM_ATTRIBUTES.ACTIVE_DEACTIVATE_CONFIRM_TITLE')}
          message={t('CUSTOM_ATTRIBUTES.ACTIVE_DEACTIVATE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}

export default CustomAttributeBomMaster;
